import { useCreateSync } from 'api/HightouchAPI';
import { PAGE_TITLE, ExitModalVariants } from 'modules/dataWarehouse/constants';
import { useEffect, useState } from 'react';
import { Takeover } from 'ui/workflows/takeover';
import { ExitModal } from './ExitModal';
import { TakeoverBody } from './TakeoverBody';

export const CREATE_SYNC_TEXT = {
  errorTitle: 'We’ve ran into a snag!',
  errorSubtitle:
    'There was an error loading the data. Please try refreshing the page or wait a few minutes and try again.',
  id: 'create-sync',
  iframeName: 'createSyncIframe',
  iframeTitle: 'Create data sync',
  takeoverTitle: PAGE_TITLE,
};

type CreateSyncTakeoverProps = { sourceId?: string; onClose: () => void };

export const CreateSyncTakeover = ({ onClose, sourceId }: CreateSyncTakeoverProps) => {
  const { data, error, isLoading, mutate } = useCreateSync();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    mutate({ sourceId });
  }, []);

  return (
    <>
      <Takeover
        Body={
          <TakeoverBody
            errorSubtitle={CREATE_SYNC_TEXT.errorSubtitle}
            errorTitle={CREATE_SYNC_TEXT.errorTitle}
            hasError={!!error}
            id={CREATE_SYNC_TEXT.id}
            name={CREATE_SYNC_TEXT.iframeName}
            title={CREATE_SYNC_TEXT.iframeTitle}
            url={data?.url}
          />
        }
        isLoading={isLoading}
        isMainApp
        isOverlay
        noPadding
        onClose={() => (error ? onClose() : setShowModal(true))}
        size="100%"
        title={CREATE_SYNC_TEXT.takeoverTitle}
      />
      {showModal && (
        <ExitModal
          handleCancel={() => setShowModal(false)}
          handleConfirm={onClose}
          variant={ExitModalVariants.CREATE_SYNC}
        />
      )}
    </>
  );
};
